// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import views from './views';

// +++ Cordchat - overrides the mattermost-redux `entities` reducer to add users.statusesDetail
import entities from './entities';

// ---

export default {
    views,
    entities
};



// WEBPACK FOOTER //
// ./reducers/index.js